import { all, spawn, call } from 'redux-saga/effects';
import authWatcher from './Auth/Auth.saga';
import timelineWatcher from './Timeline/Timeline.saga';
import timerWatcher from './Timer/Timer.saga';
import teamWatcher from './Team/Team.saga';
import memberWatcher from './Member/Member.saga';
import memberSessionsWatcher from './Member/MemberSessions.saga';
import regularizationWatcher from './Regularization/Regularization.saga';
import leaveWatcher from './Leave/Leave.saga';
import pocWatcher from './Poc/Poc.saga';
import manageTeamsWatcher from './ManageTeams/ManageTeams.saga';
import clientAccessWatcher from './ClientAccess/ClientAccess.saga';
import planFeaturesWatcher from './PlanFeatures/PlanFeatures.saga';

// spawn() (rather than fork()) detaches each feature's saga tree from the
// root's error boundary: an uncaught error in one feature's saga can no
// longer cancel every other feature's watchers. The try/catch keeps a crash
// isolated to that one feature instead of taking down the whole tree.
function isolate(watcher) {
  return spawn(function* watcherIsolation() {
    try {
      yield call(watcher);
    } catch (error) {
      console.error(`Uncaught error in ${watcher.name} saga:`, error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    isolate(authWatcher),
    isolate(teamWatcher),
    isolate(memberWatcher),
    isolate(memberSessionsWatcher),
    isolate(timelineWatcher),
    isolate(manageTeamsWatcher),
    isolate(clientAccessWatcher),
    isolate(pocWatcher),
    isolate(timerWatcher),
    isolate(regularizationWatcher),
    isolate(leaveWatcher),
    isolate(planFeaturesWatcher),
  ]);
}
